import { tokens } from '@fluentui/react-components';
import React from 'react';

interface ITreeLineProps {
    height: number;
    width: number;
}

export const TreeLineIcon: React.FC<ITreeLineProps> = (props: ITreeLineProps) => {
    const height: number = props.height ?? 31;
    const width: number = props.width ?? 8;
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d={`M 1 0 V ${height} H ${width}`} stroke={tokens.colorBrandStroke1} strokeWidth='0.5' />
        </svg>
    );
};
